module.exports = __webpack_public_path__ + "img/1876.ebd27637.jpg";